import store from "../store/index.js";

const owner = {
  mounted(el, binding) {
    const targetUserId = binding.value;
    const currentUserId = store.getters._getCurrentUser?.id;

    if (!targetUserId || targetUserId !== currentUserId) {
      el.parentNode.removeChild(el);
    }
  },
};

export default owner; 